import { createContext, FC, ReactNode, useContext } from 'react'

export const OrganisationConfigContext = createContext<string>(null as unknown as string)

interface Props {
  children: ReactNode
  organisationId: string
}

export const OrganisationConfigProvider: FC<Props> = ({ organisationId, children }) => {
  return (
    <OrganisationConfigContext.Provider value={organisationId}>
      {children}
    </OrganisationConfigContext.Provider>
  )
}

export const useOrganisationId = () => useContext(OrganisationConfigContext)
